var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ffbb00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.249 9.29813C22.1621 9.20398 22.0569 9.12893 21.94 9.07764C21.8231 9.02635 21.697 8.99992 21.5695 9H10.4306C10.3029 8.99968 10.1766 9.02595 10.0595 9.07717C9.94231 9.12839 9.83689 9.20346 9.74977 9.29769C9.66266 9.39192 9.59572 9.50329 9.55315 9.62483C9.51057 9.74637 9.49328 9.87547 9.50234 10.0041L10.3693 22.2591C10.4044 22.7322 10.6152 23.1745 10.9595 23.4973C11.3037 23.8201 11.756 23.9997 12.2258 24H19.7799C20.2488 23.9985 20.7 23.8184 21.0433 23.4957C21.3865 23.173 21.5967 22.7314 21.6317 22.2591L22.4978 10.0041C22.5066 9.87544 22.4891 9.74637 22.4463 9.6249C22.4035 9.50344 22.3363 9.3922 22.249 9.29813ZM20.5726 10.875L20.1772 16.5H11.823L11.4275 10.875H20.5726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassIcon);
export default __webpack_public_path__ + "static/media/glass-icon.805869bcb183001c7ff55d3ae438a93b.svg";
export { ForwardRef as ReactComponent };